import { render, staticRenderFns } from "./studentsEdit.vue?vue&type=template&id=ddb46e26&scoped=true"
import script from "./studentsEdit.vue?vue&type=script&lang=js"
export * from "./studentsEdit.vue?vue&type=script&lang=js"
import style0 from "./studentsEdit.vue?vue&type=style&index=0&id=ddb46e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb46e26",
  null
  
)

export default component.exports